const TRACK_INSET = "1.5rem";

export const getTrackPosition = (fraction: number): string =>
  `calc(${TRACK_INSET} + (100% - ${TRACK_INSET} * 2) * ${fraction})`;
